import { createTV } from "tailwind-variants";

export const tv = createTV({
  twMergeConfig: {
    prefix: "oui-",
  },
});
